$(function(){
  $('footer .footer-block--menu h2.footer-block__heading').on('click',function(){
    $(this).toggleClass('is-open');
    $(this).next().slideToggle();
  });
});

// link
const links = document.querySelectorAll('a.list-menu__item');
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//cart
const cart_caption = document.querySelector('.cart__blocks__caption');
const cart_button = document.querySelector('.cart__ctas');
cart_button.prepend(cart_caption);



// cart saw-extra-note
const sawExtraNote = document.querySelector(".saw-extra-note");

function replaceText() {
    if (sawExtraNote.textContent.includes("Only % discounts")) {
      sawExtraNote.textContent = "割引率は%のみです";
    } else if (sawExtraNote.textContent.includes("Shipping discounts can't")) {
      sawExtraNote.textContent = "送料無料クーポンは利用できません";
    } else if (sawExtraNote.textContent.includes("Invalid code:")) {
      sawExtraNote.textContent = "このクーポンは利用できません";
    } else if (sawExtraNote.textContent.includes("Invalid discount code")) {
      sawExtraNote.textContent = "このクーポンは利用できません";
    } else if (sawExtraNote.textContent.includes("Discount requires a minimum purchase of ¥3,000")) {
      sawExtraNote.textContent = "割引には最低購入金額3,000円が必要です";
    } else if (sawExtraNote.textContent.includes("Discount requires a minimum purchase of ¥5,000")) {
      sawExtraNote.textContent = "割引には最低購入金額5,000円が必要です";
    }
}
// MutationObserver の設定
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        if (mutation.type === "childList" || mutation.type === "characterData") {
            replaceText(); // テキストが変更されたらチェック＆置換
        }
    });
});

observer.observe(sawExtraNote, { childList: true, characterData: true, subtree: true });
replaceText();